import levenshtein from "fast-levenshtein";

function normalize(str) {
  return str
    .toLowerCase()
    .replace(/[^\p{L}]/gu, "") // keep letters incl åäö
    .trim();
}

function similarity(a, b) {
  const d = levenshtein.get(a, b);
  return 1 - d / Math.max(a.length, b.length);
}

export function findBestSlug(rawName, foodInfo, cutoff = 0.45) {
  const cleaned = cleanIngredientName(rawName);
  const inputNorm = normalize(cleaned);

  if (!inputNorm) {
    return { slug: "COULD_NOT_FIND", name: "Unknown" };
  }

  let best = {
    slug: null,
    name: "Unknown",
    score: 0
  };

  for (const [slug, data] of Object.entries(foodInfo)) {
    const slugNorm = normalize(slug);
    const nameNorm = normalize(data.name || "");

    // full-string match
    const s1 = similarity(inputNorm, slugNorm);
    const s2 = nameNorm ? similarity(inputNorm, nameNorm) : 0;

    // token match (VERY important for compounds)
    const tokens = inputNorm.split(/(?=[a-zåäö])/);
    let tokenScore = 0;

    for (const t of tokens) {
      tokenScore = Math.max(
        tokenScore,
        similarity(t, slugNorm),
        similarity(t, nameNorm)
      );
    }

    const score = Math.max(s1, s2, tokenScore);

    if (score > best.score) {
      best = {
        slug,
        name: data.name || slug,
        score
      };
    }
  }

  if (best.score < cutoff) {
    return { slug: "COULD_NOT_FIND", name: "Unknown" };
  }

  return {
    slug: best.slug,
    name: best.name
  };
}


function cleanIngredientName(name) {
  return name
    .toLowerCase()
    .replace(/[\d.,/]/g, "")
    .replace(/\b(krm|tsk|msk|dl|cl|ml|l|g|kg|hg|st|styck|klyfta|klyftor|burk)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

